import React from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Spin } from "antd";
import VisualitzacioContainerMapa from "./VisualitzacioContainerMapaObservadors";
import { setTitolApartat, obtenirObservadorsEspecies } from "../../actions";
import { getPeticioVisualitzacioEnCurs, getUsuari } from "../../reducers";
import {
  MISSATGE_SPIN_VISUALITZACIO,
  TITOL_VISUALITZACIO_OBSERVADORS
} from "../../constantsFormularis";
import { rutaLogin } from "../../routes";
import { calFerLogin, senseRols, tokenDecoded } from "../../utils/usuariRols";
import { LOCAL_STORAGE_USER } from "../../constantsObservacions";
import { NotificacioError } from "../Notification";
import { esLlistaBuida } from "../../utils/formularis";

class Visualitzacio extends React.Component {
  componentDidMount() {
    this.props.setTitolApartat(TITOL_VISUALITZACIO_OBSERVADORS);
    this.obtenirObservadorsEspecies();
  }

  obtenirObservadorsEspecies = () => {
    this.props
      .obtenirObservadorsEspecies()
      .then(dades => {
        if (dades.error || (dades.payload && dades.payload.message)) {
          return NotificacioError(
            "Avís llistat d'observadors i espècies",
            dades.error ? dades.error : dades.payload.message
          );
        }
        if (esLlistaBuida(dades.payload, "observadorsEspecies")) {
          return NotificacioError(
            "Avís",
            "No s'han trobat observadors ni espècies."
          );
        }
      })
      .catch(error => {
        if (error.message && error.titol) {
          return NotificacioError(error.titol, error.message);
        }
      });
  };

  recuperarUsuariRender = usuari => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    if (!token) {
      return <Redirect to={rutaLogin} />;
    }
    if (!calFerLogin(usuari)) {
      return this.tokenTrobatRender(usuari);
    } else {
      return this.tokenTrobatRender(tokenDecoded(token.token));
    }
  };

  tokenTrobatRender = usuari => {
    const { isPeticioEnCurs } = this.props;

    if (senseRols(usuari)) {
      return <Redirect to={rutaLogin} />;
    }

    return (
      <Spin
        spinning={isPeticioEnCurs}
        tip={MISSATGE_SPIN_VISUALITZACIO}
        delay={300}
      >
        <VisualitzacioContainerMapa />
      </Spin>
    );
  };

  render() {
    return this.recuperarUsuariRender(this.props.usuari);
  }
}

Visualitzacio.propTypes = {
  isPeticioEnCurs: PropTypes.bool,
  setTitolApartat: PropTypes.func.isRequired,
  obtenirObservadorsEspecies: PropTypes.func.isRequired,
  usuari: PropTypes.object
};

const mapStateToProps = state => {
  return {
    isPeticioEnCurs: getPeticioVisualitzacioEnCurs(state),
    usuari: getUsuari(state)
  };
};

export default connect(mapStateToProps, {
  setTitolApartat,
  obtenirObservadorsEspecies
})(Visualitzacio);
